"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeTFunc = void 0;
const I18nNotInitializedError_1 = require("./I18nNotInitializedError");
const makeTFunc = (i18nInstance, ns, lng) => {
    return (key, options) => {
        if (!i18nInstance.isInitialized)
            throw new I18nNotInitializedError_1.I18nNotInitializedError();
        return i18nInstance.t(key, { ...options, ns, lng });
    };
};
exports.makeTFunc = makeTFunc;
//# sourceMappingURL=makeTFunc.js.map